/* global angular, _ */

'use strict';

import * as _ from 'lodash-es';

(function () {
  angular
    .module('specsguardApp')
    .service('Utils', UtilsFunction);

  UtilsFunction.$inject = ['Auth'];

  function UtilsFunction (Auth) {
    /**
     * Simple decorator that decorate objects and if given a function,
     * binds that functions' scope to the given object.
     * @param  {Object} item     The item that you want to decorate.
     * @param  {String} propname The property name that you want to add.
     * @param  {Object} property Could be any native type or an object, basically, anything.
     * @return {Object}          The decorated object.
     */
    this.decorate = function (item, propname, property) {
      if (angular.isUndefined(item[propname])) {
        // property does not exist on the item so we can go ahead and decorate it
        item[propname] = property;
        // if property is a function we bind it's `this` context to the given item:
        if (angular.isFunction(property)) {
          property = property.bind(item);
        }
      }
      return;
    };

    /**
     * @method {Function} canWriteProject
     * @param {Object} User - user object
     * @param {Object} options - options object
     * @param {Object} options.project - The project including project.users
     * @param {String[]} options.projectLevels - ENUM ['owner', 'manager', 'contributor', 'guest']
     * @param {Number} options.accessLevel - application level needed
     * */
    this.canWriteProject = function (User = Auth.getCurrentUser(), {
      project = {} as any,
      projectLevels = ['manager', 'contributor', 'guest'],
      accessLevel = 1,
    }) {
      const userAccessLevel = Auth.getUserAccessLevel();

      if (project.archived) {
        return false;
      }

      // Override for (app) admin
      if (userAccessLevel >= 8) {
        return true;
      }

      const projectUser = _.find(project.users, (projUser) => {
        return (projUser.userId._id === User._id && projUser.active && !projUser.deleted);
      });

      const userProjectRole = angular.isUndefined(projectUser) ? 'undefined' : projectUser.projectRole;

      let accessLevelPassed = (angular.isNumber(accessLevel) && userAccessLevel >= accessLevel) ||
        (accessLevel === null);

      let projectLevelPassed = (projectLevels.indexOf(userProjectRole) > -1);

      return (accessLevelPassed && projectLevelPassed);
    };

    this.isUserManager = function (Authorisation, project) {
      if (Authorisation.getUserAccessLevel() >= 8) {
        return true;
      }

      return _.find(project.users, function (user) {
        return (user.projectRole === 'manager' && user.userId._id === Authorisation.getCurrentUser()._id);
      });
    };

    function parseNumber (nr) {
      if (angular.isNumber(nr)) {
        return nr;
      }

      if (nr === '' || angular.isUndefined(nr) || nr === null) {
        return '';
      }

      const num = nr.replace(/,/g, '.');
      return (!/\./.test(num)) ? parseInt(num) : parseFloat(num);
    }

    this.parseNumber = parseNumber;

    /**
     * Various path utilities.
     * @type {Object}
     */
    this.path = {
      /**
       * returns the given path minus the last part, replicates the behaviour of Array.shift.
       * Hence the name.
       * @param  {String} path the path that you want to shift the last part from.
       * @param  {String} separator of the path.
       * @return {String} the given path minus the last part.
       */
      shift: function (path, separator) {
        return _.without(path.split(separator), _.last(path.split(separator))).join(separator);
      },
      /**
       * executes path.shift (above) N times.
       * WARNING: does not yet have proper error handling (f.e. path is 3 sections, shifting 4 times... oops)
       * @WARNING: does not yet have proper error handling (f.e. path is 3 sections, shifting 4 times... oops)
       * @param  {String} path the path that you want to shift the last part from.
       * @param  {String} separator of the path.
       * @param  {Number} shiftThisMany shifts the path n many times.
       * @return {String} the given path minus the last part.
       */
      shiftN: (path, separator, shiftThisMany) => {
        let newPath = path;
        const _this = this;
        _.times(shiftThisMany, () => {
          // $log.debug('path before... ', newPath)
          newPath = _this.shift(newPath, separator);
          // $log.debug('path after... ', newPath)
        });
        return newPath;
      },
      /**
       * switches the last part of the path. uses path.shift internally.
       * @param  {String} path the path that you want to switch the last part of.
       * @param  {String} separator of the path.
       * @param  {String} switchWith, the path part that you want to switch to. May be a multi-part path.
       * @return {String} new path with switched last path part.
       */
      switchLast: function (path, separator, switchWith) {
        return this.shift(path, separator) + separator + switchWith;
      },
      /**
       * concatenates a new path part to the given path
       * @param  {String} path        the given path.
       * @param  {String} separator   path separator.
       * @param  {String} newPathPart the new path part.
       * @return {String}             the full path with the new path part concatenated.
       */
      concat: function (path, separator, newPathPart) {
        return path.split(separator).concat(newPathPart).join(separator);
      }
    };
  }
})();
